/*
 * Copyright (c) 2024-2025 Nodals AI Ltd
 * All rights reserved.
 */

import { Logger } from '../logger';
import { BidRequestObject, PrebidFormattedKeyValues } from '../types/prebid';
import { deepMerge } from '../util';

const logger = Logger.getInstance();

class IndexExchange {
  static bidderName = 'ix';

  static updateBidRequest(
    bidRequest: BidRequestObject,
    targetingData: PrebidFormattedKeyValues
  ): void {
    const allValues: string[] = Object.values(targetingData).flatMap((adUnit) =>
      Object.values(adUnit)
    );
    const uniqueValues: string[] = Array.from(new Set(allValues));
    if (uniqueValues.length > 0) {
      logger.info(
        `Adding Index Exchange nodals targeting data to bid request: ${uniqueValues.join(', ')}`
      );
      bidRequest.ortb2Fragments.bidder[IndexExchange.bidderName] =
        bidRequest.ortb2Fragments.bidder[IndexExchange.bidderName] || {};
      deepMerge(bidRequest.ortb2Fragments.bidder[IndexExchange.bidderName], {
        user: {
          ext: {
            data: {
              nodals: uniqueValues,
            },
          },
        },
      });
    }
  }
}

export default IndexExchange;
